<div fxLayout="column">
    <div *ngIf="!!saleOrderDetails">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-sm="column">
            <div  *ngIf="!!storeDetails">
                <h2 class="text-left">From</h2>
                <h3 class="text-muted text-left">{{storeDetails.name}}</h3>
                <h4 class="text-muted text-left">{{storeDetails.address}}</h4>
                <h4 class="text-muted text-left">Phone: {{storeDetails.phone | phone:'US' }} </h4>
                <h4 class="text-muted text-left">Eamil: {{storeDetails.reply_to_email}}</h4>
            </div>
            <div *ngIf="!!userDetails">
                <h2 class="text-left">To</h2>
                <h3 class="text-muted text-left">{{userDetails.first_name}} {{userDetails.last_name}}</h3>
                <h4 class="text-muted text-left">{{userDetails.address}}</h4>
                <h4 class="text-muted text-left">
                    {{userDetails.city}}, {{userDetails.state}}, {{userDetails.zipcode}}
                </h4>
                <h4 class="text-muted text-left">Phone: {{ userDetails.phone_number | phone:'US' }}</h4>
                <h4 class="text-muted text-left">Eamil: {{userDetails.email_id}}</h4>
            </div>
            <div *ngIf="!!saleOrderDetails">
                <h2 class="text-left">Sale Order Info</h2>
                <h3 class="text-muted text-left">Sale order # {{saleOrderDetails.sale_order_number}}</h3>
                <h4 class="text-muted text-left">
                    Date of order: {{saleOrderDetails.date_of_order | date: 'MM/dd/yyyy hh:mm:ss'}}
                </h4>
                <h4 class="text-muted text-left">
                    Date of delivery: {{saleOrderDetails.date_of_delivered | date:'MM/dd/yyyy'}}
                </h4>
                <h4 class="text-muted text-left">Order status: {{saleOrderDetails.status}}</h4>
            </div>
        </div>
        <div class="mt-2 mb-2">
            <h1 class="text-primary text-center">Sale Order</h1>
        </div>
        <div class="mat-table sale-order-table mt-1">
            <div class="mat-header-row">
            <div class="mat-header-cell" fxFlex="45%">Product Description</div>
            <div class="mat-header-cell">Frequency</div>
            <div class="mat-header-cell">Quantity</div>
            <div class="mat-header-cell">Bottles</div>
            <div class="mat-header-cell">Unit Price</div>
            <div class="mat-header-cell">Extended Price</div>
            </div>
            <div *ngFor="let order of saleOrderItemDetails" class="mat-row">
                <div class="mat-cell" fxFlex="45%">
                <span>
                    {{order.description}}
                </span>
                </div>
                <div class="mat-cell">
                    <span>
                    {{order.frequency}}
                    </span>
                </div>
                <div class="mat-cell">
                    <span>
                    {{order.quantity}}
                    </span>
                </div>
                <div class="mat-cell">
                    <span>
                    {{order.bottle_quantity}}
                    </span>
                </div>
                <div class="mat-cell">
                    <span>
                        {{!!storeDetails && storeDetails.currency}}{{order.unit_cost | number: '1.2-2'}}
                    </span>
                </div>
                <div class="mat-cell">
                    <span>
                        {{!!storeDetails && storeDetails.currency}}{{order.extended_price | number: '1.2-2'}}
                    </span>
                </div>
            </div>
        </div>
        <div class="mt-3" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-sm="column">
            <!-- SaleOrder Comments -->
            <div class="mt-1" fxFlexOrder="1" fxFlexOrder.xs="2" fxFlex="50%">
                <h3 class="text-muted">Order Comments</h3>
                <mat-accordion multi="true">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                            Customer Comments
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div fxLayout="column">
                            <div fxFlex="100" *ngFor="let comment of contactComments">
                                <div fxLayout="column">
                                    <div fxLayout="row" fxFlex>
                                        <h5>{{comment.comment}}</h5>
                                    </div>
                                    <div fxLayout="row" fxFlex fxLayoutAlign="end">
                                        <p class="mat-small" color="primary">{{comment.time_stamp | date:'dd-MM-yyyy hh:mm:ss'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <!-- End -->
            <!-- SaleOrder Total -->
            <div fxLayout="column" fxFlexOrder="2" fxFlexOrder.xs="1">
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
                    <h3>Subtotal</h3> 
                    <h3 class="text-muted" *ngIf="!!saleOrderDetails && !!storeDetails">
                        {{storeDetails.currency}}
                        {{saleOrderDetails.sub_total | number: '1.2-2'}}
                    </h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
                    <h3>Delivery Fee</h3> 
                    <h3 class="text-muted" *ngIf="!!saleOrderDetails && !!storeDetails">
                        {{storeDetails.currency}}
                        {{saleOrderDetails.delivery_fee | number: '1.2-2'}}
                    </h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
                    <h3>Bottle Deposit</h3> 
                    <h3 class="text-muted" *ngIf="!!saleOrderDetails && !!storeDetails">
                        {{saleOrderDetails.bottle_delivered}} x 
                        {{storeDetails.currency}}{{saleOrderDetails.bottle_rate | number: '1.2-2'}} = 
                        {{storeDetails.currency}}{{saleOrderDetails.bottle_delivered_rate | number: '1.2-2'}}
                    </h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
                    <h3>Bottle Returned</h3> 
                    <h3 class="text-muted" *ngIf="!!saleOrderDetails && !!storeDetails">
                        {{storeDetails.currency}}{{saleOrderDetails.bottle_returned}}
                    </h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
                    <h3>Total Payable</h3> 
                    <h3 class="text-muted" *ngIf="!!saleOrderDetails && !!storeDetails">
                        {{storeDetails.currency}}{{saleOrderDetails.total_payable | number: '1.2-2'}}
                    </h3>
                </div>
            </div>
            <!-- End -->
        </div>
    </div>
    <!-- Display Sale Order Not Found -->
    <div *ngIf="!!saleOrderDetails === false">
        <h4 class="text-muted text-center">No Sale Order Found!</h4>
    </div>
    <!-- End -->
    <div class="mb-2">
        <button mat-raised-button color="primary"
            (click)="goBack()">Go Back</button>
    </div>
</div>
